import { render, staticRenderFns } from "./BackgroundInfo.vue?vue&type=template&id=341f2caf&scoped=true&"
import script from "./BackgroundInfo.vue?vue&type=script&lang=js&"
export * from "./BackgroundInfo.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundInfo.vue?vue&type=style&index=0&id=341f2caf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341f2caf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VResponsive,VRow})
